import { CSSProperties } from 'react'

import styled from 'styled-components'

type FlexProps = {
  direction?: CSSProperties['flexDirection']
  alignItems?: CSSProperties['alignItems']
  justifyContent?: CSSProperties['justifyContent']
  padding?: CSSProperties['padding']
}

export const Flex = styled.section<FlexProps>`
  display: flex;
  flex-direction: ${({ direction }) => direction || 'row'};
  align-items: ${({ alignItems }) => alignItems || 'center'};
  justify-content: ${({ justifyContent }) => justifyContent || 'center'};

  padding: ${({ padding }) => padding || '0px 135px'};
  max-width: 1440px;
`
